import React, { useEffect, useState } from 'react';
import { BiMessageSquareEdit, BiTrash } from "react-icons/bi";
import { connect } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { deleteProject } from '../../redux/actions/project';
import { deleteReview, fetchAllReviews } from '../../redux/actions/review';
import EditProjectModal from './EditProjectModal';

const ManageReviewTable = ({dispatch, reviews}) => {
  const [modalShow, setModalShow] = useState(false);
  const [changedField, setChangedField] = useState({id:'', projectname:'', description:'', collectionSize:'', mintPrice:'', mintRevenue:'', teamStatus:'', website:'', twitter:'', twitterFollowers:'', discord:'', discordMember:'', megiceden:'',  summary:''  });

  
const [modalType] = useState('edit');
    const { addToast } = useToasts();

    const toggleModal = () => setModalShow(!modalShow);

  const handleSubmit= ()=>{
   
    setModalShow(false)
  }
    useEffect(()=>{
        dispatch(fetchAllReviews())
       },[dispatch])

      

       const handleDelete = (id) => {
        dispatch(deleteReview(id, addToast))
       }


    return (
      <>
        <section className="author-area">
          <div className="container">
          

          <table className="table table-secondary table-hover table-responsive-lg">
  <thead>
    <tr className=''>
      
    
      <th scope="col">Image</th>
      <th scope="col">Project Name</th>
      <th scope="col">Review</th>
      <th scope="col">Rating</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody>
    {reviews && reviews.map(review=>(
        <tr key={review._id}>
            <td><img src={review.project.image} width={45} height={45} alt={review.project.projectname} /></td>
        <td>{review.project.projectname}</td>
        <td>{review.review.slice(0,70)}</td>
        <td>{review.rating}</td>
        <td className='table-action'>
          {/* <span onClick={()=>handleEdit(project)} className='mr-2 edit'><BiMessageSquareEdit/></span> */}
          <span onClick={()=>handleDelete(review._id)} className='delete'><BiTrash/></span>
        </td>
      </tr>
    ))}
   
    
  </tbody>
</table>
          </div>
        </section>

        {modalShow && <EditProjectModal  show={modalShow} changedField={changedField} setChangedField={setChangedField} modalType={modalType} toggle={toggleModal} handleSubmit={handleSubmit}/>}
      </>
    );
};


function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      reviews: state.review.reviewData
    };
  }

export default connect(mapStateToProps)(ManageReviewTable);
